import React from "react";
import ForgotPassword from "../components/ForgotPassword/ForgotPassword"; // ✅ Updated path
import Footer from "../components/Footer/Footer"; // ✅ Import Footer

const ForgotPasswordPage = () => {
  return (
    <div className="forgot-password-page">
      <div className="flex justify-center items-center h-screen bg-gray-100 forgot-password-content">
        <ForgotPassword />
      </div>
      <Footer /> 
    </div>
  );
};

export default ForgotPasswordPage;
